import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(2),
    backgroundColor: "white",
    minWidth: "400px",
    maxWidth: "420px",
    borderRadius: "5px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    gap:theme.spacing(2)
  },
  companyHeading: { marginBottom: theme.spacing(1) },
  textField: {
    marginBottom: theme.spacing(2),
    lineHeight: "2rem",
  },
  companyFooter: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "flex-end",
  },
  cancel: { marginRight: theme.spacing(1) },
}));
